import { render, staticRenderFns } from "./SSDashBoard.vue?vue&type=template&id=2bd996a5&scoped=true&"
import script from "./SSDashBoard.vue?vue&type=script&lang=js&"
export * from "./SSDashBoard.vue?vue&type=script&lang=js&"
import style0 from "./SSDashBoard.vue?vue&type=style&index=0&id=2bd996a5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd996a5",
  null
  
)

export default component.exports